import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog4D() {
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
          const [formType, setFormType] = useState(""); // stores which button opened the form
      const [contactForm, setContactForm] = useState({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
      const handleContactChange = (e) => {
        const { name, value } = e.target;
        setContactForm((prev) => ({ ...prev, [name]: value }));
      };
      
      
      const isBusinessEmail = (email) => {
        const freeDomains = [
          "gmail.com",
          "yahoo.com",
          "hotmail.com",
          "outlook.com",
          "aol.com",
          "icloud.com",
          "mail.com",
          "live.com"
        ];
        const domain = email.split("@")[1]?.toLowerCase();
        if (!domain) return false;
        return !freeDomains.includes(domain);
      };
      
      
      const handleContactSubmit = async (e) => {
        e.preventDefault();
       
        setLoading(true); // show loading message
        const { fullname, company, website, email, phone, message} = contactForm;
      
      
        // Basic validation
        if (!fullname || !email || !message || !company || !phone ) {
          alert("Please fill all required fields.");
            setLoading(false); // show loading message
      
          return;
        }
      if (!isBusinessEmail(email)) {
          alert("Please enter a business email, not Gmail/Yahoo/etc.");
            setLoading(false); // show loading message
      
          return;
        }
       
      
        try {
            try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
          const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

          });
      
          if (response.ok) {
             setShowSuccessModal(true);  // ✅ This triggers modal to open
             setLoading(false); // show loading message
             setContactForm({
              fullname: "",
              company: "",
              website: "",
              email: "",
              phone: "",
              message: "",
            });
          } else {
            alert("Error sending message.");
          }
        } catch (err) {
          console.error(err);
          alert("Error sending message.");
        }
      };
        
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
                    {showSuccessModal && (
                      <motion.div
                        className="modal-overlay show"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background: "rgba(0,0,0,0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 9999,
                        }}
                      >
                        <motion.div
                          className="modal show"
                          initial={{ scale: 0.8, opacity: 0 }}
                          animate={{ scale: 1, opacity: 1 }}
                          exit={{ scale: 0.8, opacity: 0 }}
                          transition={{ duration: 0.3 }}
                          style={{
                            background: "#fff",
                            padding: "30px",
                            borderRadius: "10px",
                            width: "400px",
                            textAlign: "center",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                          }}
                        >
                          <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                            Message Sent!
                          </h2>
                          <p>Thank you for contacting us. We will get back to you shortly.</p>
                          <button className="vc rg lk gh ml il hi gi _l"
                            onClick={() => setShowSuccessModal(false)}
                           
                          >
                            Close
                          </button>
                        </motion.div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                  
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
             <div className="container">
               <div className="left">
          <img src="../images/blogim4.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
           Intent Data in HRTech: Unlocking Smarter Growth & Better Targeting
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span>  Oct 19, 2025
                </li>
                  <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
             <p className="mb bgimh">
         How HRTech Companies Use Intent Signals to Find, Engage, and Convert the Right Buyers
              </p>

                <p className="jutfy">
In the fast-growing world of HRtech, competition is fierce. From recruitment platforms and employee engagement tools to workforce analytics and payroll systems, countless vendors are fighting for attention in a crowded marketplace. And with HR leaders receiving hundreds of pitches a month, it’s getting harder to break through the noise.
<br/>
<br/>
So how do you ensure your message reaches the right buyers at the right time?    </p>
              <p className="mb bgimh">
           Intent Data — a game-changer in how HRtech companies identify, prioritize, and convert high-quality leads.
              </p>
             
               <p className="mb bgimh">
                What is Intent Data?
              </p>
 <p className="jutfy">
Intent data captures behavioral signals that indicate a person or company is actively researching a topic, solution, or challenge — often before they directly engage with your brand.
<br/><br/>
These signals come from sources like: </p>
              
              <ul className="jutfy">
                <li>•	Searches for specific keywords (e.g., “employee performance management tools”)</li>
 <li>•	Website visits to HR-related product categories or competitor pages</li>
 <li>•	Content downloads or webinar registrations</li>
 <li>•	Social media and forum activity</li>
 <li>•	Job postings and organizational changes (technographic/firmographic triggers)
</li>
              </ul>

                <p className="jutfy">
In short, intent data helps you know who is in-market and what they care about — even before they fill out a form.
              </p>
              <p className="mb bgimh">
           Why Intent Data Matters in HRTech
              </p>
               <p className="jutfy">
                The HR buyer’s journey is unique. HR professionals often:
              </p>
              <ul className="jutfy">
                <li>•	Buy based on urgency (compliance, attrition, hiring surges)</li>
<li>•	Involve multiple stakeholders (CHRO, HRIS, IT, Finance)</li>
<li>•	Need tailored messaging based on company size, maturity, or industry

</li>
              </ul>

              <p className="jutfy">
Intent data helps HRtech vendors rise above generic outreach by providing insights that inform both timing and personalization.  
            </p>
              
               <p className="mk3 ij">Here’s why it’s so powerful:</p>
              
               <p className="mb bgimh">
        1.	Target the Right Accounts at the Right Time
              </p>
              <p className="jutfy">
Not every company is ready to buy HR software today — but intent data tells you who’s actively researching solutions. Instead of guessing or relying solely on firmographics, you can prioritize outreach to accounts showing high intent around specific topics.
<br/>
<br/>
For example:
              </p>
              <ul className="jutfy">
                <li>
                  •	A company showing high intent around “HR automation tools” might be evaluating vendors — perfect timing for your outreach. </li>
    <li>•	A spike in searches related to “remote onboarding” may suggest they’re hiring globally and need support.

                </li>
              </ul>
              <p className="jutfy">
This makes your prospecting far more efficient and effective.
              </p>
              
               <p className="mb bgimh">
         2.	Personalize Messaging Based on Interests
              </p>
              <p className="jutfy">
                Intent signals don’t just tell you who is looking — they tell you what they’re looking for. Use this to customize messaging and content based on their research interests.
                <br/>
                If an HR manager is consuming content around “diversity & inclusion platforms,” you can tailor your email or ad to highlight your solution’s D&I analytics capabilities.
                <br/>
                <br/>
                This level of relevance boosts:
              </p>
               <ul className="jutfy">
                <li>•	Email open and reply rates</li>
<li>•	Engagement with landing pages</li>
<li>•	Conversion rates at every funnel stage
</li>
               </ul>
             <p className="mb bgimh">
       3.	Power Account-Based Marketing (ABM) Campaigns
              </p>
           
              <p className="jutfy">
Intent data is a key pillar of any ABM strategy, allowing you to:
              </p>
<ul className="jutfy">
  <li>
   <li> •	Build target account lists based on behavioral signals  </li>
<li>•	Segment accounts by topics they’re researching (e.g., “employee experience” vs. “HR compliance”)  </li>
<li>•	Deliver highly relevant ads, content, and outreach to specific accounts  </li>
•	Alert your sales team when buying signals spike
  </li>
</ul>
 <p className="jutfy">
Instead of casting a wide net, you’re zeroing in on the accounts that actually matter.
              </p>
              <p className="mb bgimh">
              4.	Enable Sales with Real-Time Intelligence
              </p>
               <p className="jutfy">
                Your sales reps shouldn’t have to guess which accounts are warming up or why. Intent data equips them with:
               </p>
<ul className="jutfy">
  <li>
    •	A list of high-intent companies in your ICP </li>
 <li>•	Topic-level insights for better discovery calls </li>
 <li>•	Timing cues for follow-up or re-engagement </li>
 <li>•	Prioritized call lists based on intent scores
  </li>
</ul>
               <p className="jutfy">
                This means less cold calling and more strategic conversations that lead to pipeline.
               </p>
               
                 <p className="mb bgimh">
          5.	Accelerate Nurturing and Retargeting Campaigns
              </p>
               <p className="jutfy">
                Some HR buyers may not convert right away — but with intent data, you can continue nurturing them in a way that reflects their current interest level.
                <br/>
                <br/>
                For example:
              </p>
             <ul className="jutfy">
                <li>
                  •	A lead that didn’t respond to your initial email but now shows renewed interest in “HR analytics” can be moved to a new nurture path. </li>
  <li>•	Use display or LinkedIn retargeting to re-engage them with content aligned to their latest behavior.

                </li>
              </ul>
               <p className="jutfy">
            You stay top-of-mind without wasting marketing spend on cold prospects.
              </p>
              <p className="mb bgimh">
          Real-World HRTech Use Cases
              </p>
               <p className="jutfy">
                Here’s how real HRtech companies are using intent data today:
              </p>
             <ul className="jutfy">
              <li>
                •	Recruitment Platforms track companies with surging hiring needs and engage them with candidate sourcing tools </li>
   <li>•	Employee Experience Tools target HR teams researching “engagement surveys” or “pulse feedback” solutions </li>
   <li>•	Compliance & Policy Solutions identify organizations consuming content on “labor law changes” or “HR audits” </li>
   <li>•	LMS Platforms engage leads browsing for “employee training” and “learning management systems”

              </li>
             </ul>
               <p className="jutfy">Whether you sell to SMBs or enterprises, intent data helps you get ahead of the buyer journey.</p>
              
                 <p className="mb bgimh">
         Final Thoughts: Intent Data = Smarter HRTech Growth
              </p>
               <p className="jutfy">
              Intent data helps HRtech companies stop guessing and start growing. By tapping into the real behaviors of HR buyers — and acting on those signals with AI and human strategy — you can:
              </p>
               <ul className="jutfy">
              <li>•	Focus on the right leads</li>
<li>•	Engage them with relevant content</li>
<li>•	Shorten sales cycles</li>
<li>•	And ultimately, close more deals
</li>
              </ul>
              <p className="jutfy">If you're in HRtech and not using intent data, you're already a step behind. But it's never too late to start.</p>
            
              <p className="mb bgimh">
       Ready to Activate Intent Data for Your HRTech Go-To-Market Strategy?
       <br/>
       <br/>
       Let us help you identify high-intent leads and turn them into real pipeline.
              </p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
                 <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: Intent Data in HRTech: Unlocking Smarter Growth & Better Targeting");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog4D;
